import { useNavigate } from "react-router-dom";
import bgImg5 from "../../assets/images/communication/COMMUNICATION.webp";
import Hero from "../../Components/HeroIndustries/HeroIndustries";
import { ServiceCardView } from "../../Components/ServiceCardView";
const Index = () => {
  const navigate = useNavigate();
  return (
    <>
      <Hero
        pageName="SERVICES / CUSTOMER EXPERIENCE AND DIGITAL TRANSFORMATION"
        pageIntro="Create intuitive, omnichannel experiences with scalable UI and automation solutions."
        pageIntroPara={""}
        alt="img"
        image={bgImg5}
      />

      <ServiceCardView
        list={[
          {
            id: "customer-experience",
            title: "Customer Experience",
            desc: "Design personalized, omnichannel customer journeys to enhance engagement and satisfaction.",
            technologies:
              "Salesforce, Adobe Experience Cloud, AWS Personalize, BigQuery ML, Miro, UXPressia",
            features: [
              "Customer 360 views",
              "Behavioral segmentation",
              "Journey mapping",
              "Real-time personalization",
            ],
            impact: "30% higher satisfaction, 25% increased retention",
            caseStudy: {
              client: "Global Retail Chain",
              challenge:
                "Inconsistent customer experiences across channels reduced engagement.",
              solution:
                "NucleusTeq designed omnichannel journeys with Salesforce, personalizing interactions via AWS Personalize.",
              outcome:
                "Increased customer satisfaction by 28% and retention by 23%.",
            },
            imagePrompt: {
              description:
                "A retail dashboard with omnichannel customer journey analytics, featuring Salesforce icons. Use blue and white (#007BFF, #FFFFFF).",
              style: "Retail, analytical, digital art, 800x400px",
              altText: "Retail dashboard with omnichannel customer experience",
            },
            buttunData: {
              buttonText: "Transform Your Customer Experience",
              buttonAction: () => {
                navigate("/contact");
              },
            },
          },
          {
            id: "customer-360",
            title: "Customer 360 Implementation",
            desc: "Build comprehensive customer views for unified, personalized experiences across platforms.",
            technologies: "Salesforce, Adobe Experience Cloud",
            features: [
              "Unified customer profiles",
              "Real-time integration",
              "Personalized interactions",
              "Scalable platforms",
            ],
            impact: "40% improved engagement, 20% higher retention",
            caseStudy: {
              client: "Financial Institution",
              challenge:
                "Fragmented customer data limited personalized banking services.",
              solution:
                "NucleusTeq implemented Salesforce Customer 360, unifying data for personalized banking experiences.",
              outcome: "Improved engagement by 38% and retention by 18%.",
            },
            imagePrompt: {
              description:
                "A financial dashboard with unified customer profiles, featuring Salesforce icons. Use blue gradient (#E6F0FA to #007BFF).",
              style: "Financial, analytical, digital art, 800x400px",
              altText: "Financial dashboard with Customer 360 implementation",
            },
            buttunData: {
              buttonText: "Transform Your Customer Experience",
              buttonAction: () => {
                navigate("/contact");
              },
            },
          },
          {
            id: "behavioral-segmentation",
            title: "Behavioral Segmentation",
            desc: "Deploy AI models for behavioral segmentation, enabling targeted customer experiences.",
            technologies: "AWS Personalize, BigQuery ML",
            features: [
              "Behavioral analytics",
              "Targeted segmentation",
              "Real-time processing",
              "Personalized campaigns",
            ],
            impact: "35% higher conversion rates, 25% improved targeting",
            caseStudy: {
              client: "E-commerce Platform",
              challenge:
                "Generic marketing campaigns reduced conversion rates.",
              solution:
                "NucleusTeq deployed AWS Personalize for behavioral segmentation, optimizing targeted campaigns.",
              outcome:
                "Increased conversion rates by 33% and improved targeting by 23%.",
            },
            imagePrompt: {
              description:
                "An e-commerce dashboard with behavioral segmentation analytics, featuring AWS Personalize icons. Use blue and white (#007BFF, #FFFFFF).",
              style: "E-commerce, analytical, digital art, 800x400px",
              altText: "E-commerce dashboard with behavioral segmentation",
            },
            buttunData: {
              buttonText: "Transform Your Customer Experience",
              buttonAction: () => {
                navigate("/contact");
              },
            },
          },
          {
            id: "journey-mapping",
            title: "Journey Mapping Services",
            desc: "Create detailed customer journey maps to optimize touchpoints and experiences.",
            technologies: "Miro, UXPressia",
            features: [
              "Visual journey maps",
              "Touchpoint optimization",
              "Customer insights",
              "Strategic alignment",
            ],
            impact: "30% improved customer experience, 20% reduced churn",
            caseStudy: {
              client: "Telecom Operator",
              challenge:
                "Poorly optimized customer touchpoints increased churn rates.",
              solution:
                "NucleusTeq used Miro to map customer journeys, optimizing touchpoints for better experiences.",
              outcome:
                "Improved customer experience by 28% and reduced churn by 18%.",
            },
            imagePrompt: {
              description:
                "A telecom dashboard with customer journey maps, featuring Miro icons. Use blue gradient (#E6F0FA to #007BFF).",
              style: "Telecom, analytical, digital art, 800x400px",
              altText: "Telecom dashboard with customer journey mapping",
            },
            buttunData: {
              buttonText: "Transform Your Customer Experience",
              buttonAction: () => {
                navigate("/contact");
              },
            },
          },
          {
            id: "cx-strategy",
            title: "CX Strategy Consulting",
            desc: "Design data-driven CX strategies to drive engagement and business outcomes.",
            technologies: "Strategic frameworks, KPI analytics",
            features: [
              "Data-driven roadmaps",
              "Stakeholder workshops",
              "KPI alignment",
              "Experience optimization",
            ],
            impact: "40% improved CX outcomes, 25% higher satisfaction",
            caseStudy: {
              client: "Retail Corporation",
              challenge:
                "Lack of a unified CX strategy reduced customer satisfaction.",
              solution:
                "NucleusTeq conducted KPI-driven workshops to design a data-driven CX strategy.",
              outcome: "Improved CX outcomes by 38% and satisfaction by 23%.",
            },
            imagePrompt: {
              description:
                "A retail dashboard with CX strategy analytics, featuring KPI framework icons. Use blue and white (#007BFF, #FFFFFF).",
              style: "Retail, strategic, digital art, 800x400px",
              altText: "Retail dashboard with CX strategy analytics",
            },
            buttunData: {
              buttonText: "Transform Your Customer Experience",
              buttonAction: () => {
                navigate("/contact");
              },
            },
          },

          {
            id: "mobile-app",
            title: "Mobile App Development",
            desc: "Develop high-performance mobile apps for seamless, scalable user experiences.",
            technologies: "Flutter, React Native",
            features: [
              "Cross-platform apps",
              "High performance",
              "User-centric design",
              "Scalable architecture",
            ],
            impact: "50% faster app interactions, 30% higher engagement",
            caseStudy: {
              client: "E-commerce Platform",
              challenge: "Slow mobile apps reduced customer engagement.",
              solution:
                "NucleusTeq developed a React Native-based mobile app, optimizing performance.",
              outcome:
                "Increased app interactions by 48% and engagement by 28%.",
            },
            imagePrompt: {
              description:
                "An e-commerce mobile app with high-performance UI, featuring React Native icons. Use blue and white (#007BFF, #FFFFFF).",
              style: "E-commerce, technical, digital art, 800x400px",
              altText: "E-commerce mobile app with high-performance UI",
            },
            buttunData: {
              buttonText: "Transform Your Customer Experience",
              buttonAction: () => {
                navigate("/contact");
              },
            },
          },
          {
            id: "web-ui",
            title: "Web UI Development",
            desc: "Build scalable web interfaces for intuitive, high-performance user experiences.",
            technologies: "React, Angular",
            features: [
              "Responsive design",
              "Interactive interfaces",
              "Scalable frontends",
              "User-friendly navigation",
            ],
            impact: "40% improved engagement, 25% reduced bounce rates",
            caseStudy: {
              client: "Financial Institution",
              challenge: "Outdated web interfaces increased bounce rates.",
              solution:
                "NucleusTeq developed React-based web UI, enhancing user engagement.",
              outcome:
                "Improved engagement by 38% and reduced bounce rates by 23%.",
            },
            imagePrompt: {
              description:
                "A financial web interface with interactive UI, featuring React icons. Use blue gradient (#E6F0FA to #007BFF).",
              style: "Financial, technical, digital art, 800x400px",
              altText: "Financial web interface with interactive UI",
            },
            buttunData: {
              buttonText: "Transform Your Customer Experience",
              buttonAction: () => {
                navigate("/contact");
              },
            },
          },
          {
            id: "accessibility",
            title: "Accessibility Implementation",
            desc: "Ensure WCAG 2.1-compliant interfaces with ARIA labels for inclusive access.",
            technologies: "WCAG 2.1, ARIA labels",
            features: [
              "Accessible design",
              "Screen reader support",
              "Inclusive interfaces",
              "Compliance adherence",
            ],
            impact: "99.9% accessibility compliance, 20% broader user reach",
            caseStudy: {
              client: "Telecom Operator",
              challenge:
                "Non-compliant interfaces limited accessibility for diverse users.",
              solution:
                "NucleusTeq implemented WCAG 2.1-compliant interfaces with ARIA labels.",
              outcome:
                "Achieved 100% compliance and increased user reach by 18%.",
            },
            imagePrompt: {
              description:
                "A telecom dashboard with accessibility metrics, featuring WCAG 2.1 icons. Use blue and white (#007BFF, #FFFFFF).",
              style: "Telecom, compliant, digital art, 800x400px",
              altText: "Telecom dashboard with accessibility implementation",
            },
            buttunData: {
              buttonText: "Transform Your Customer Experience",
              buttonAction: () => {
                navigate("/contact");
              },
            },
          },

          {
            id: "digital-transformation",
            title: "Digital Transformation",
            desc: "Accelerate enterprise transformation with automation and cloud-native solutions for efficiency.",
            technologies:
              "UiPath, Automation Anywhere, Spring Boot, Kubernetes, Jenkins, GitLab",
            features: [
              "Process automation",
              "Cloud-native apps",
              "CI/CD pipelines",
              "Agile methodologies",
            ],
            impact: "40% improved efficiency, 25% cost savings",
            caseStudy: {
              client: "Global Logistics Firm",
              challenge: "Manual processes slowed logistics operations.",
              solution:
                "NucleusTeq implemented UiPath automation and Kubernetes-based cloud apps for efficiency.",
              outcome: "Improved efficiency by 38% and reduced costs by 23%.",
            },
            imagePrompt: {
              description:
                "A logistics dashboard with automation and cloud-native metrics, featuring UiPath icons. Use blue and white (#007BFF, #FFFFFF).",
              style: "Logistics, technical, digital art, 800x400px",
              altText: "Logistics dashboard with digital transformation",
            },
            buttunData: {
              buttonText: "Transform Your Customer Experience",
              buttonAction: () => {
                navigate("/contact");
              },
            },
          },

          {
            id: "transformation-consulting",
            title: "Digital Transformation Consulting",
            desc: "Design digital transformation roadmaps with agile methodologies for business alignment.",
            technologies: "Agile frameworks, strategic planning",
            features: [
              "Transformation roadmaps",
              "Agile methodologies",
              "Business alignment",
              "Change management",
            ],
            impact: "40% faster transformation, 25% improved outcomes",
            caseStudy: {
              client: "Media Company",
              challenge:
                "Slow digital transformation hindered content delivery innovations.",
              solution:
                "NucleusTeq designed agile transformation roadmaps, aligning with content delivery goals.",
              outcome:
                "Sped up transformation by 38% and improved outcomes by 23%.",
            },
            imagePrompt: {
              description:
                "A media dashboard with transformation roadmap metrics, featuring agile framework icons. Use blue and white (#007BFF, #FFFFFF).",
              style: "Media, strategic, digital art, 800x400px",
              altText: "Media dashboard with transformation consulting",
            },
            buttunData: {
              buttonText: "Transform Your Customer Experience",
              buttonAction: () => {
                navigate("/contact");
              },
            },
          },
        ]}
        buttunData={{
          buttonText: "Start Your Journey",
          buttonAction: () => {
            navigate("/contact");
          },
        }}
      />
    </>
  );
};

export default Index;
